export default __webpack_public_path__ + "static/media/BA95NPremium.4c583ab6.svg";